import cs from 'classnames';
import type { FC } from 'react';
export interface IHeaderBarWelcomeProps {
  step: number;
}
const HeaderBarWelcome: FC<IHeaderBarWelcomeProps> = ({
  step
}) => {
  return <div className="flex flex-col" data-sentry-component="HeaderBarWelcome" data-sentry-source-file="HeaderBarWelcome.tsx">
      <div className="flex flex-row gap-1 text-blackThree">
        <span>مرحله</span>
        <span>{step}</span>
        <span>از</span>
        <span>3</span>
      </div>
      <div className="mb-4 mt-2 flex flex-row gap-2">
        <span id="1" className={cs('h-[3px] bg-blueFour w-full')} />
        <span id="2" className={cs((step === 2 || step === 3) && '!bg-blueFour', 'h-[3px] bg-blackFour w-full')} />
        <span id="3" className={cs(step === 3 && '!bg-blueFour', 'h-[3px] bg-blackFour w-full')} />
      </div>
    </div>;
};
export default HeaderBarWelcome;